// extracted by mini-css-extract-plugin
export default {"box":"WhiteBox_box__BbNK5","padding-large":"WhiteBox_padding-large__J+bOV","padding-small":"WhiteBox_padding-small__aksQm"};